<template>
    <div class="header-curve-wrapper">
        <div class="header-curve" :style="{backgroundImage: 'url(/static/img/home/header/curve.png)'}"></div>
        <div class="slides">
          <div v-for="(slide, index) in slides" :key="index">
            <transition name="fade">
              <div v-if="slide.id === activeSlide" class="slide-img" :style="{backgroundImage: 'url(' + slide.img + ')'}"></div>
            </transition>
            <transition name="fade">
              <div v-if="slide.id === activeSlide" class="slide-img-mobile" :style="{backgroundImage: 'url(' + slide.imgMobile + ')'}"></div>
            </transition>
          </div>
        </div>
        <div class="slides-nav-wrapper">
          <div class="slides-nav">
            <transition-group name="slide" tag="div">
              <div class="slides-nav-item" v-for="(slide, index) in slidesNav" :key="slide.id">
                <div class="slides-nav-img" :class="{ 'underline' : slide.id === activeSlide }">
                  <img @click="changeSlide(index)" :src="slide.imgMini" :class="{ 'active-img' : slide.id === activeSlide }" alt="">
                  <div v-if="slide.id === activeSlide" class="slides-nav-progress" :style="{ 'height' : progress + '%'}"></div>
                </div>
                <!-- <div class="slides-nav-text" @click="changeSlide(index)">
                  <h2 :class="{'text-dark' : slide.dark, 'show-text' : slide.id === activeSlide}">{{slide.title}}</h2>
                  <p :class="{'text-dark' : slide.dark, 'show-text' : slide.id === activeSlide}">{{slide.subtitle}}</p>
                </div> -->
              </div>
            </transition-group>
          </div>
        </div>
      <div class="slide-animation">
        <img class="mouse" src="/static/img/scroll.svg" alt="">
      </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      slides: [
        {
          id: 0,
          img: "/static/img/home/header/bg_1.jpg",
          imgMobile: "/static/img/home/header/bg_1m.jpg",
          imgMini: "/static/img/home/header/m_1.png",
          title: "Countinuous improvement",
          subtitle: "Sales by countries 2017",
          dark: true
        },
        {
          id: 1,
          img: "/static/img/home/header/bg_2.jpg",
          imgMobile: "/static/img/home/header/bg_2m.jpg",
          imgMini: "/static/img/home/header/m_2.png",
          title: "Building & Contruction",
          subtitle: "sustainable development",
          dark: true
        },
        {
          id: 2,
          img: "/static/img/home/header/bg_3.jpg",
          imgMobile: "/static/img/home/header/bg_3m.jpg",
          imgMini: "/static/img/home/header/m_3.png",
          title: "100 000 tons/year",
          subtitle: "Rolling capacity",
          dark: false
        },
        {
          id: 3,
          img: "/static/img/home/header/bg_4.jpg",
          imgMobile: "/static/img/home/header/bg_4m.jpg",
          imgMini: "/static/img/home/header/m_4.png",
          title: "37 Years we invest",
          subtitle: "in the most promising technologies",
          dark: false
        },
        {
          id: 4,
          img: "/static/img/home/header/bg_5.jpg",
          imgMobile: "/static/img/home/header/bg_5m.jpg",
          imgMini: "/static/img/home/header/m_5.png",
          title: "New Production",
          subtitle: "Capabilities in 2019",
          dark: false
        }
      ],
      activeSlide: 0,
      slidesNav: [],
      rotateSpeed: 5000,
      progress: 0,
      rotater: undefined,
      progresser: undefined
    };
  },
  mounted() {
    // Copy the array of slices for the sake of animations to work
    this.slidesNav = this.slides.slice();

    // Start rotating the slides when app loads
    this.rotateSlides();
    this.progressing();
  },
  methods: {
    changeSlide(i) {
      this.activeSlide = i;
      this.progress = 0;
      clearInterval(this.rotater);
      this.rotateSlides();
    },
    rotateSlides() {
      this.rotater = setInterval(() => {
        if (this.activeSlide < this.slides.length - 1) {
          this.activeSlide++;
        } else {
          this.activeSlide = 0;
        }
        this.progress = 0;
      }, this.rotateSpeed);
    },
    progressing() {
      this.progresser = setInterval(() => {
        this.progress += 0.5;
      }, this.rotateSpeed / 200);
    }
  },
  destroyed() {
    clearInterval(this.rotater);
    clearInterval(this.progresser);
  }
};
</script>

<style scoped>
.header-curve-wrapper {
  height: 100vh;
  /* max-height: 100vh; */
  position: relative;
}
.header-curve {
  background-size: 100% 100%;
  background-position: center;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;
}
.slides {
  border-left: 2px solid #fff;
  height: calc(100% - 2px);
  overflow: hidden;
  position: relative;
  width: 100%;
  /* z-index: 3; */
}
.slides > div {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
.slide-img {
  background-size: cover;
  background-position: right;
  height: 100%;
  width: 100%;
}
.slides-nav-wrapper {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: flex-start;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 2;
}
.slides-nav {
  /* height: calc(100vh - 100px);
  overflow: hidden; */
  padding: 0 40px;
  width: 100%;
}
.slides-nav-item {
  align-items: center;
  display: flex;
  margin-bottom: 20px;
}
.slides-nav-item:first-child {
  margin-top: 60px;
}
.slides-nav-img {
  background-size: cover;
  border-radius: 10px;
  cursor: pointer;
  height: 13vh;
  margin-right: 36px;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.slides-nav-img img {
  /* object-position: right;
  object-fit: cover; */
  -webkit-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  filter: grayscale(100%);
  height: 100%;
  opacity: 0.5;
  -webkit-transition: all 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
  -moz-transition: all 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
  -ms-transition: all 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
  -o-transition: all 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
  transition: all 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
  width: 23%;
}
.slides-nav-img .active-img {
  -webkit-filter: grayscale(0%);
  -ms-filter: grayscale(0%);
  filter: grayscale(0%);
  opacity: 1;
}
.slides-nav-item .underline::before {
  background-color: rgba(255, 255, 255, 0.6);
  top: 0;
  content: "";
  height: 100%;
  left: 0;
  position: absolute;
  width: 5px;
  z-index: 1;
}
.slides-nav-progress {
  /* background-color: #004787; */
  background-color: #29a5d9;
  top: 0;
  left: 0;
  height: 0;
  max-height: 100%;
  position: absolute;
  width: 5px;
  z-index: 1;
}
/* .slides-nav-text {
  cursor: pointer;
} */
.slides-nav-text h2 {
  bottom: 100px;
  color: #fff;
  font-size: 58px;
  font-weight: 700;
  left: 28%;
  opacity: 0;
  position: absolute;
  transition: all 1s;
}
.slides-nav-text p {
  bottom: 80px;
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  left: 28%;
  opacity: 0;
  position: absolute;
  transition: all 1s;
}
.slides-nav-text .show-text {
  opacity: 1;
}
.slides-nav-text .text-dark {
  color: #00305b;
}
.fade-enter-active,
.fade-leave-active {
  -webkit-transition: all 1s ease-in-out;
  -moz-transition: all 1s ease-in-out;
  -ms-transition: all 1s ease-in-out;
  -o-transition: all 1s ease-in-out;
  transition: all 1s ease-in-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: scale(1.1);
}
.slide-enter-active,
.slide-leave-active {
  -webkit-transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
  -ms-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
  transform: scale(0.5);
}
.slide-animation {
  align-items: center;
  bottom: 50px;
  display: flex;
  flex-direction: column;
  height: 65;
  justify-content: flex-start;
  position: absolute;
  right: 80px;
  width: 38px;
  z-index: 5;
}
.mouse {
  height: 65px;
  width: 100%;
}
.slide-img-mobile {
  display: none;
}
@media screen and (max-width: 1600px) {
  /* .slides-nav-img {
    height: 11vh;
  }
  .slides-nav-item {
    margin-bottom: 15px;
  } */
  .slides-nav-text h2 {
    font-size: 52px;
  }
}
@media screen and (max-width: 1440px) {
  /* .slides-nav-img {
  } */
  .slides-nav-item {
    margin-bottom: 15.4px;
  }
  .slides-nav-text h2 {
    font-size: 46px;
  }
}
@media screen and (max-width: 1366px) {
  .slides-nav-img {
    /* height: 14vh; */
  }
  .slides-nav-text h2 {
    font-size: 42px;
  }
}
@media screen and (max-width: 1280px) {
  .header-curve-wrapper {
    /* this is for vh to work on mobile devices  */
    height: calc(var(--vh, 1vh) * 100);
  }
}
@media screen and (max-width: 1279px) {
  .slides-nav,
  .header-curve {
    display: none;
  }
}
@media screen and (max-width: 1000px) {
  .slide-animation,
  .mouse,
  .slides-nav,
  .header-curve,
  .slide-img {
    display: none;
  }
  .slide-img-mobile {
    background-size: cover;
    background-position: center;
    display: block;
    height: 100%;
    width: 100%;
  }
  .slides {
    border-left: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/HeaderCurve.vue